import classnames from 'classnames';
import { ReactElement } from 'react';
import { useCAWContext } from '../CAW';
import CalendarDone from './CalendarDone';
import CalendarMeta from './CalendarMeta';
import FlexDates from './FlexDates';
import HorizontalLine from '../../horizontal-line';
import { getCalendarCurrencyCode } from '@micro-apps/env';
import { useNightlyRatesCalendar } from '@fshr/experiments';
import DatePicker from './DatePicker';
type Props = {
	onClose?: () => unknown;
	openDialog?: () => unknown;
	setupScrollEvent?: boolean;
};
export default function Calendar({
	onClose,
	openDialog,
	setupScrollEvent = true,
}: Props): ReactElement<any> {
	const { planStore, isDesktop } = useCAWContext();
	const { enabled: nightlyRatesEnabled } = useNightlyRatesCalendar();
	return (
		<div className="CAW_Calendar flex flex-col">
			<div className="CAW_Calendar-wrapper">
				<DatePicker
					setupScrollEvent={setupScrollEvent}
					openDialog={openDialog}
					baseClassName="CAW_Calendar"
				/>
			</div>
			{isDesktop && (
				<>
					<HorizontalLine additionalClasses="border-border-subtle" />
					{planStore?.search.hotelCode && planStore?.config.flexDatesAllowed && (
						<>
							<div className="Flex-Dates spacing-card-padding-xs">
								<FlexDates />
							</div>
							<HorizontalLine additionalClasses="border-border-subtle" />
						</>
					)}
					<div className="flex flex-col spacing-card-padding-xs">
						{planStore?.search.hotelCode && planStore?.calendarResult && (
							<div
								className={classnames('Calendar-Meta CAW_Calendar-Meta', {
									'Calendar-Meta--active': planStore?.search.hotelCode,
									'CAW_Calendar-Meta--active': planStore?.search.hotelCode,
									'pb-[15px]': nightlyRatesEnabled,
								})}
							>
								<CalendarMeta
									nightlyRatesExperiment={nightlyRatesEnabled}
									currencyCode={
										nightlyRatesEnabled
											? getCalendarCurrencyCode(planStore?.calendarResult)
											: undefined
									}
								/>
							</div>
						)}

						{onClose && <CalendarDone onClose={onClose} />}
					</div>
				</>
			)}
		</div>
	);
}
